import React, { useState, useEffect, useRef, forwardRef, useImperativeHandle } from "react";
import axios from "axios";
import Select from 'react-select'
import {
    handleTextInput,
    handleImeiInput,
    handleNumberInput,
    handleCustomInput,
    handlePriceInput
} from "../../utils/inputUtils";

import moment from 'moment-timezone';
import 'moment/locale/es'; // Importa el idioma español
// Asegúrate de establecer el idioma a español
moment.locale('es');

const RegisterTableRetiro = forwardRef((props, ref) => {
    const { options: phoneOptions, onSendDataCat, onSendDataSubCat, onSendDataSegment, sendSubCat } = props;

    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [phone, setPhone] = useState(null);

    const createDateSet = moment.tz("America/Lima").format("dddd DD [de] MMMM [del] YYYY");
    const classNameColorID = sendSubCat === '3' ? '8' : '9';

    const catRef = useRef();
    const subCatRef = useRef();
    const segmentRef = useRef();
    const descriptionRef = useRef();
    const phoneRef = useRef();
    const phonePriceRef = useRef();
    const nameRef = useRef();
    const paternalSurRef = useRef();
    const maternalSurRef = useRef();
    const fmRef = useRef();
    const fmAmountRef = useRef();
    const imeiRef = useRef();
    const dniRef = useRef();
    const emailRef = useRef();
    const phoneNumberRef = useRef();
    const cashAmountRef = useRef();
    const onlinePayRef = useRef();
    const onlineAmountRef = useRef();
    const applicanRef = useRef();

    useImperativeHandle(ref, () => ({
        getValues: () => ({
            cat: catRef.current?.value,
            subCat: subCatRef.current?.value,
            segment: segmentRef.current?.value,
            description: descriptionRef.current?.value,
            phone: phone?.value,
            phonePrice: phonePriceRef.current?.value,
            name: nameRef.current?.value,
            paternalSur: paternalSurRef.current?.value,
            maternalSur: maternalSurRef.current?.value,
            fm: fmRef.current?.value,
            fmAmount: fmAmountRef.current?.value,
            imei: imeiRef.current?.value,
            dni: dniRef.current?.value,
            email: emailRef.current?.value,
            phoneNumber: phoneNumberRef.current?.value,
            cashAmount: cashAmountRef.current?.value,
            onlinePay: onlinePayRef.current?.value,
            onlineAmount: onlineAmountRef.current?.value,
            applicant: userSelected?.value,
        })
    }));

    const handleChangeUser = (option) => {
        console.log(option);
        setUserSelected(option);
    };

    const changeCat = (e) => {
        onSendDataCat({
            cat: e.target.value
        })
    };

    const [subCat, setSubCat] = useState(3);
    const changeSubCat = (e) => {
        // console.log(subCatRef.current.value);
        onSendDataSubCat({
            cat: catRef.current.value,
            subCat: e.target.value,
        });
        setSubCat(e.target.value);
    }

    const changeSegment = (e) => {
        onSendDataSegment({
            cat: catRef.current.value,
            subCat: subCatRef.current.value,
            segment: e.target.value
        })
    };

    const [userOptions, setUserOptions] = useState([]);
    const [userSelected, setUserSelected] = useState(null);
    const getUsers = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API}/register/get-users`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem("token")}`
                }
            });

            const data = response.data;
            // console.log(data);
            const adaptedOptions = data.data.map(user => ({
                value: user.idNumber,
                label: user.nombre + ' ' + user.apellidoPaterno
            }));

            setUserOptions(adaptedOptions)
            // Aquí haces lo que necesites con la respuesta
        } catch (error) {
            console.error("Error al obtener los datos:", error);
            alert(error.message || "Ocurrió un error al cargar los datos.");
        }
    };


    useEffect(() => {
        getUsers()
    }, []);


    return (
        <div className={`registerTable registerTable13 registerTableInList`}>
            <table>
                <caption>{createDateSet}</caption>
                <thead>
                    <tr>
                        <th>Tipo de Registro</th>
                        <th>Tipo de Producto</th>
                        <th>Fuente</th>
                        <th>Descripción</th>
                        <th>Solicitante</th>
                        <th>Monto Efectivo</th>
                        <th>Pago Online</th>
                        <th>Monto Online</th>
                    </tr>
                </thead>

                <tbody>
                    <tr>
                        <td className="cat">
                            <select defaultValue="5" onChange={changeCat} ref={catRef}>
                                <option value="1">Crédito</option>
                                <option value="2">Contado</option>
                                <option value="3">Egreso</option>
                                <option value="4">Ingreso</option>
                                <option value="5">Retiro</option>
                            </select>
                        </td>
                        <td className="subCat">
                            <select disabled defaultValue={sendSubCat} onChange={changeSubCat} ref={subCatRef}>
                                <option value="1">Efectivo</option>
                            </select>
                        </td>
                        <td className="segment">
                            <select disabled defaultValue="4" onChange={changeSegment} ref={segmentRef}>
                                <option value="4">MovilPro</option>
                            </select>
                        </td>
                        <td width="25%" className="tableWidth">
                            <input
                                type="text"
                                ref={descriptionRef}
                                onInput={(e) => handleCustomInput(e, 100)}
                                id="descriptionAdd"
                            />
                        </td>
                        <td width="20%">
                            <Select
                                options={userOptions}
                                value={userSelected}
                                onChange={handleChangeUser}
                                // defaultValue={selectedOption}
                                placeholder={'Seleccióne al Solicitante'}
                                className="selectForm formItem selectPhone"
                                name="applicantId"
                                ref={applicanRef}
                            />
                        </td>
                        <td width="10%" className="withSymbol">
                            <span>S/.</span>
                            <input
                                type="text"
                                defaultValue={0.00}
                                onInput={handlePriceInput}
                                ref={cashAmountRef}
                            />
                        </td>
                        <td>
                            <select defaultValue="0" ref={onlinePayRef} id="onlinePayAdd" disabled>
                                <option value="0">Selecciónar</option>
                                <option value="1">Yape</option>
                                <option value="5">Culqi Yape</option>
                                <option value="2">Tarjeta</option>
                                <option value="6">Culqi Tarjeta</option>
                                <option value="3">Transferencia</option>
                            </select>
                        </td>
                        <td width="5%" className="withSymbol">
                            <span>S/.</span>
                            <input
                                type="text"
                                defaultValue={0.00}
                                onInput={handlePriceInput}
                                ref={onlineAmountRef}
                                id="onlineAmountAdd"
                                disabled
                            />
                        </td>
                    </tr>

                </tbody>
            </table>
        </div>
    );
});

export default RegisterTableRetiro;
